import {
  Modal,
  Box,
  Button,
  SpaceBetween,
} from "@cloudscape-design/components-themed";
import { COMMON_LABELS } from "../../default-constants";
import { LABELS, RESULT_NG, RESULT_OK } from "../constants";
import { getApiConfirmationResult, getComment, isSameStore } from "../util";
import { ConfirmationStoreInfo } from "../../../features/api-interfaces";
import { Dispatch, SetStateAction } from "react";

interface IConfirmationResultModal {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  storeList: ConfirmationStoreInfo[];
  setStoreList: Dispatch<SetStateAction<ConfirmationStoreInfo[] | undefined>>;
  modalStore: ConfirmationStoreInfo;
}

/**
 * 店舗 確認結果モーダル
 */
const ConfirmationResultModal = (props: IConfirmationResultModal) => {
  const { visible, setVisible, modalStore, storeList, setStoreList } = props;

  /**
   * 確認結果の入力ハンドラ.
   * @param {ConfirmationStoreInfo} modalStore 更新対象の店舗情報
   * @param {string} confirmationResultValue 入力された確認結果value
   */
  const confirmationResultCheck = (
    modalStore: ConfirmationStoreInfo,
    confirmationResultValue: string
  ) => {
    setVisible(false);

    const index = storeList.findIndex((store) =>
      isSameStore(
        store,
        modalStore.applicationStatusNo,
        modalStore.individualHandlingReason
      )
    );

    if (index !== -1) {
      const newStoreList = [...storeList];
      newStoreList[index] = {
        ...newStoreList[index],
        confirmationResult: getApiConfirmationResult(confirmationResultValue),
        comment: getComment(confirmationResultValue, modalStore.comment),
      };
      setStoreList(newStoreList);
    }
  };

  return (
    <Modal
      onDismiss={() => setVisible(false)}
      visible={visible}
      size={"small"}
      footer={
        <Box float="right">
          <Button
            variant={"normal"}
            onClick={() => confirmationResultCheck(modalStore, "")}
          >
            {COMMON_LABELS.BTNS.CLEAR}
          </Button>
        </Box>
      }
      header={LABELS.CONFIRMATION_RESULT}
    >
      <SpaceBetween size={"xxl"} direction={"horizontal"}>
        <Button
          variant={"normal"}
          onClick={() => confirmationResultCheck(modalStore, RESULT_OK.value)}
        >
          {RESULT_OK.label}
        </Button>
        <Button
          variant={"normal"}
          onClick={() => confirmationResultCheck(modalStore, RESULT_NG.value)}
        >
          {RESULT_NG.label}
        </Button>
      </SpaceBetween>
    </Modal>
  );
};

export default ConfirmationResultModal;
